<ui-popup-layout>
  <ui-popup-body>
    <div class="tw-p-1 tw-text-base-text/[.65]">
      <st-profile></st-profile>

      <ng-container [ngSwitch]="subjectView$ | async">
        <ng-container *ngSwitchCase="SubjectView.Selector">
          <st-subject-selector [selectedSubject]="subject$ | async" (subjectSelected)="onSubjectSelected($event)"></st-subject-selector>
        </ng-container>
        <ng-container *ngSwitchCase="SubjectView.Task">
          <st-recommendations (changeSubject)="openSubjectSelector()"></st-recommendations>
        </ng-container>
      </ng-container>
    </div>

    <!-- Daily learning minutes -->
    <div class="tw-p-2.5 tw-bg-base-text/[.04] tw-rounded-lg tw-mb-2.5 tw-hidden">
      <div class="tw-flex tw-flex-col tw-gap-2 tw-rounded-lg">
        <div class="tw-flex tw-justify-between tw-items-center">
          <div class="tw-text-base-text/[.65] tw-text-base/9">
            <div class="tw-flex tw-items-end">
              <span class="tw-font-bold tw-text-3xl">20</span>/25 {{ 'dashboard.layout.labels.minutes' | translate }}
            </div>
          </div>
          <div
            class="tw-flex tw-gap-1 tw-mt-2 tw-p-1 tw-pb-0 tw-text-base-text/[.65] hover:tw-cursor-pointer"
          >
            <span class="tw-underline" translate>dashboard.layout.labels.weekly_details</span>

            <fa-icon [icon]="icons.faArrowUpRightFromSquare"></fa-icon>
          </div>
        </div>
        <kendo-progressbar
          class="tw-h-6"
          emptyCssClass="!tw-bg-base-text/[.08]"
          progressCssClass="!tw-bg-success"
          [label]="false"
          [value]="80"
        ></kendo-progressbar>
      </div>
    </div>

    <!-- Rewards -->
    <div class="tw-p-2.5 tw-bg-base-text/[.04] tw-text-base-text/[.65] tw-rounded-lg tw-mb-2.5 tw-hidden">
      <div class="tw-flex tw-justify-between tw-items-center">
        <span class="tw-font-bold tw-text-3xl">$183</span>
        <div
          class="tw-flex tw-gap-1 tw-p-1 hover:tw-cursor-pointer"
        >
          <span class="tw-underline" translate>dashboard.layout.labels.rewards</span>

          <fa-icon [icon]="icons.faArrowUpRightFromSquare"></fa-icon>
        </div>
      </div>
    </div>

    <!-- Menu -->
    <div class="tw-p-2.5 tw-bg-base-text/[.04] tw-rounded-lg tw-hidden">
      <div class="tw-grid tw-grid-cols-2 tw-gap-2">
        <button
          kendoButton themeColor="base"
          class="tw-p-2 tw-bg-base-text/[.08] tw-text-base-text/[.65] tw-rounded-lg tw-border-none"
          (click)="openDashboard()"
        >
          <span class="tw-flex tw-gap-2 tw-items-center">
            <img
              src="{{ assetsPath$ | async }}/icons/dashboard.svg"
              class="tw-h-5 tw-my-1 tw-text-xl"
            />
            <span translate>dashboard.layout.actions.dashboard</span>
          </span>
        </button>
        <button kendoButton themeColor="base" class="tw-p-2 tw-bg-base-text/[.08] tw-text-base-text/[.65] tw-rounded-lg tw-border-none">
          <span class="tw-flex tw-gap-2 tw-items-center">
            <fa-icon class="tw-text-xl" [icon]="icons.faUser"></fa-icon>
            <span translate>dashboard.layout.actions.manage_profile</span>
          </span>
        </button>
      </div>
      <div>
        <button
          kendoButton themeColor="base"
          class="tw-h-11 tw-p-2.5 tw-bg-error/[.08] tw-text-error tw-rounded-lg tw-border-none tw-w-full"
          [disabled]="loading$ | async"
          (click)="onSignOut()"
        >
          <span class="tw-flex tw-justify-center tw-items-center tw-gap-2">
            <kendo-loader *ngIf="loading$ | async" type="pulsing" themeColor="error"></kendo-loader>
            <fa-icon *ngIf="!(loading$ | async)" class="tw-text-xl" [icon]="icons.faArrowRightFromBracket"></fa-icon>
            <span translate>dashboard.layout.actions.sign_out</span>
          </span>
        </button>
      </div>
    </div>
  </ui-popup-body>
</ui-popup-layout>
